






































import { Component, Vue, Watch } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import Module from '@/components/global/Module.vue';
import ModalContainer from '@/components/modals/ModalContainer.vue';
import SideMenu from '@/components/teacher/SideMenu.vue';
import TeacherMenu from '@/components/teacher/TeacherMenu.vue';
import { Teacher as ITeacher } from '@/models/Teachers';
import Teacher from '@/services/Teacher';
import Share from '@/components/teacher/Share.vue';
import { ModuleActions } from '@/models/Enums';
import { IModule, IRefModule } from '@/models/Modules';
import { IClass } from '@/models/Classes';
import Classroom from '@/services/Classroom';
import Modules from '@/services/Modules';

@Component({
  components: {
    Share,
    TeacherMenu,
    draggable,
    Module,
    ModalContainer,
    SideMenu,
  },
})
export default class Dashboard extends Vue {
  public teacher: ITeacher | null = null;
  public modulesLookup: IModule[] = [];
  public classroomModules: IModule[] = [];
  public classroom: IClass | null = null;
  public subscription: any = null;

  public async created() {
    this.teacher = await Teacher.getLoggedInTeacher();
    await this.goToFirstClassIfNone();
  }

  updated() {
    this.goToFirstClassIfNone();
  }

  public async goToFirstClassIfNone() {
    if (!this.$route.params.id) {
      let uuid;
      if (this.teacher?.classrooms && this.teacher?.classrooms.length > 0) {
        uuid = this.teacher.classrooms[0];
      } else {
        const classRooms = await Classroom.getClassRooms();
        uuid = classRooms[0]?.uuid;
      }
      await this.$router.push({ name: 'TeacherClass', params: { id: uuid } });
    }
  }

  get moduleActions() {
    return [ModuleActions.EditName, ModuleActions.Lock];
  }

  async getClassRoomData() {
    if (!this.teacher) {
      return;
    }

    const classroomId = this.$route.params.id;
    this.modulesLookup = (
      await Modules.getModulesObserverByTeacherEmail(this.teacher.email).get()
    ).docs.map(d => ({ ...d.data(), id: d.id })) as IModule[];

    const observer = Classroom.getClassroomObserver(classroomId);
    if (observer) {
      this.subscription = observer.onSnapshot(
        snapshot => {
          if (snapshot.exists) {
            const classroom = snapshot.data();
            if (!classroom) {
              return;
            }
            this.classroom = { uuid: snapshot.id, ...classroom } as IClass;
            this.classroomModules = [];

            classroom.modules.forEach((moduleRef: IRefModule) => {
              const { id, locked, nameOverride } = moduleRef;
              const module = this.modulesLookup.find(m => m.id === id);
              if (!module) {
                return;
              }
              module.id = id;
              module.locked = locked;
              // @ts-ignore
              module.nameOverride = nameOverride;
              module.name = nameOverride || module.name;
              this.classroomModules.push(module);
            });
          } else {
            this.$router.push({ name: 'TeacherClasses' });
          }
        },
        () => {
          this.$router.push({ name: 'TeacherModules' });
        }
      );
    }
  }

  @Watch('$route.params.id', { immediate: true })
  async onRouteParamChange(newId: string, oldId: string) {
    if (!this.teacher) {
      this.teacher = await Teacher.getLoggedInTeacher();
    }

    if (newId !== oldId) {
      this.modulesLookup = [];
      this.classroomModules = [];
      this.classroom = null;
      if (this.subscription) {
        this.subscription();
      }
    }

    if (newId) {
      await this.getClassRoomData();
    }
  }

  refChanged({ id, locked }: IRefModule) {
    if (!this.classroom) {
      return;
    }

    const modulesRefs = this.classroom.modules as IRefModule[];
    const ref = modulesRefs.find(ref => ref.id === id);
    if (ref) {
      ref.locked = locked;
    }

    Classroom.updateClassRoomModuleOrder(this.classroom.uuid, modulesRefs);
  }

  updateModuleOrder() {
    if (!this.classroomModules) {
      return;
    }
    const refs: IRefModule[] = this.classroomModules.map(m => {
      const ref = {
        id: m.id + '',
        locked: m.locked,
      };

      // @ts-ignore
      if (m.nameOverride) {
        // @ts-ignore
        refs.nameOverride = m.nameOverride;
      }

      return ref;
    });
    Classroom.updateClassRoomModuleOrder(this.$route.params.id, refs);
  }

  addModule() {
    this.$emit('add-module');
  }

  deleteClassroom() {
    this.$emit('delete-classroom');
  }

  editClassroomModuleName(moduleId: string) {
    const data = {
      moduleId,
      classroom: this.classroom,
    };
    this.$emit('edit-classroom-module-name', data);
  }
}
